/**
 * FN-FE-03 + FN-FIX-B1 — Step 3: NAV-kapcsolat
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Input from '../../components/ui/Input';
import Button from '../../components/ui/Button';
import Modal from '../../components/ui/Modal';
import { post } from '../../lib/api';
import { StepDots } from './OnboardingCompanyStep';
import { useToast } from '../../components/ui/Toast';

export default function OnboardingNavStep() {
  const navigate = useNavigate();
  const { token } = useAuth();
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [form, setForm] = useState({ navUser: '', navPassword: '', navSignatureKey: '', navExchangeKey: '' });

  const set = (key: string) => (e: React.ChangeEvent<HTMLInputElement>) => setForm(f => ({ ...f, [key]: e.target.value }));

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await post('/setup/nav', form);
      navigate('/onboarding/plan');
    } catch (err: any) { toast(err.message || 'Hiba történt.', 'error'); } finally { setLoading(false); }
  }

  async function handleSkip() {
    try { await post('/setup/skip-nav', {}); } catch { /* silent */ }
    navigate('/onboarding/plan');
  }

  const isValid = form.navUser.length >= 2 && form.navPassword.length >= 1 && form.navSignatureKey.length >= 1 && form.navExchangeKey.length >= 1;

  return (
    <div className="onb-bg">
      <div className="onb-wrap">
        <StepDots current={3} total={5} />

        <h1 className="onb-title">NAV-kapcsolat</h1>
        <p className="onb-sub">
          A magyar számlázáshoz a NAV Online Számla adatszolgáltatás kötelező. A Modulum automatikusan beküldi minden számládat.
          <br /><button onClick={() => setShowHelp(true)} style={{ color: 'var(--orange)', fontWeight: 600, fontSize: '13px', marginTop: '6px', background: 'none', border: 'none', cursor: 'pointer' }}>Hogyan szerzem be a NAV-credentials-t?</button>
        </p>

        <div className="onb-card">
          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <Input label="NAV technikai felhasználó *" value={form.navUser} onChange={set('navUser')} placeholder="navTechnUser01" />
              <Input label="NAV jelszó *" type="password" value={form.navPassword} onChange={set('navPassword')} placeholder="••••••••" />
              <Input label="Aláírási kulcs *" value={form.navSignatureKey} onChange={set('navSignatureKey')} placeholder="A NAV-ból másolt aláírási kulcs" />
              <Input label="Cserekulcs *" value={form.navExchangeKey} onChange={set('navExchangeKey')} placeholder="A NAV-ból másolt cserekulcs" />

              <div className="onb-info">
                Javasoljuk a teszt-módban indulni. Bármikor átállhatsz élesre a Beállítások menüben.
              </div>
            </div>

            <div className="onb-footer" style={{ justifyContent: 'space-between' }}>
              <Button variant="ghost" type="button" onClick={() => navigate('/onboarding/company')}>← Vissza</Button>
              <div style={{ display: 'flex', gap: '9px' }}>
                <Button variant="ghost" type="button" onClick={handleSkip}>Kihagyom most</Button>
                <Button type="submit" disabled={!isValid} loading={loading}>Mentés és tovább →</Button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <Modal isOpen={showHelp} onClose={() => setShowHelp(false)} title="Hogyan szerzed meg a NAV-credentials-t?">
        <ol style={{ paddingLeft: '20px', listStyleType: 'decimal' }} className="space-y-4">
          <li><strong>onlineszamla.nav.gov.hu</strong> — jelentkezz be a cég Ügyfélkapuval</li>
          <li>Hozz létre egy <strong>technikai felhasználót</strong> (Felhasználók → Új felhasználó)</li>
          <li>Másold ki a <strong>4 értéket</strong>: felhasználónév, jelszó, aláírási kulcs, cserekulcs</li>
          <li>Illeszd be ide a mezőkbe</li>
        </ol>
        <div style={{ marginTop: '16px' }}>
          <Button variant="ghost" onClick={() => setShowHelp(false)} fullWidth>Értem, bezárom</Button>
        </div>
      </Modal>
    </div>
  );
}
